module.exports = __webpack_public_path__ + "static/img/boy.c15792cc.png";